
import React from 'react';

export default class ZooTabs extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	onSelect(label, e) {
		this.setState({selected: label});
		this.props.onSelectTab(label, e);
	}
	render() {
		let { selected, tabs, rightsides } = this.props;
		let payload = [];
		selected = this.state.selected || selected || tabs[0];
		for (let i = 0; i < tabs.length; ++i) {
			let tab = tabs[i];
			payload.push(<li key={i} className={"ZooTab" + (selected === tab || selected === tab.toLowerCase() ? " ZooTabSelected" : "")} onClick={this.onSelect.bind(this, tab)}>{tab}</li> );
		}
		for (let i = 0; i < (rightsides || []).length; ++i) {
			let tab = rightsides[i];
			payload.push(<li key={tab} className={"ZooTab ZooRightsideTab" + (selected === tab || selected === tab.toLowerCase() ? " ZooTabSelected" : "")} onClick={this.onSelect.bind(this, tab)}>{tab}</li> );
		}

		return (
			<div className="ZooTabs">
				<ul>
				{payload}
				</ul>
			</div>
		)
	}
}





// WEBPACK FOOTER //
// ./src/ZooTabs.js